import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { JoyrideService } from 'ngx-joyride';
import { NbAccordionComponent, NbDialogRef, NbDialogService } from '@nebular/theme';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';

import { User } from 'app/@core/interfaces/common/users';
import {
  TutorialData,
  TutorialIDs,
} from 'app/@core/interfaces/common/CalorieFriend/tutorial';
import {
  BasePlan,
  BasePlanData,
  FitnessPlan,
  FitnessPlanData,
  MealPlan,
  MealPlanData,
  TemplatePlan,
} from 'app/@core/interfaces/common/CalorieFriend/plan';
import { ConfirmMessageDialogComponent } from 'app/@components/confirm-message-dialog/confirm-message-dialog.component';
import { GridData } from 'app/@core/interfaces/common/grid-data';
import { SmartPlanTemplateGridFilter } from 'app/@core/interfaces/common/CalorieFriend/mealTemplates';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { map, filter } from 'rxjs/operators';

@Component({
  selector: 'template-name',
  template: `<label #TemplateNameControl class="BaseName">{{
    TemplateName
  }}</label>`,
  styleUrls: [
    './plan-template-select.component.scss',
    '../../../global.component.scss',
  ],
})
export class TemplateNameComponent implements OnInit, AfterViewInit {
  Item = null;
  TemplateName = 'TEST';
  ActiveName = 'ActiveName';
  InActiveName = 'InActiveName';

  Active = true;

  @Input() value: any;
  @ViewChild('TemplateNameControl') TemplateNameElement: any = null;

  constructor() { }

  ngOnInit() {
    this.Item = this.value.Item;
    this.TemplateName = this.Item.name;
  }

  ngAfterViewInit() {
    try {
      const NameRow =
        this.TemplateNameElement.nativeElement.parentElement.parentElement
          .parentElement.parentElement.parentElement.parentElement
          .parentElement;

      if (this.Item.isSelected)
        this.TemplateNameElement.nativeElement.className =
          'ActiveName BaseName';
      else
        this.TemplateNameElement.nativeElement.className =
          'InActiveName BaseName';

      this.Item.SelectedEvent = (active) => {
        if (active)
          this.TemplateNameElement.nativeElement.className =
            'ActiveName BaseName';
        else
          this.TemplateNameElement.nativeElement.className =
            'InActiveName BaseName';
      };
    } catch { }
  }
}

export class BasePlanTemplateSelectComponent<T extends BasePlan> implements OnInit, AfterViewInit {
  ListTemplateLabel = 'Plan Templates';
  TemplateNameLabel = 'Name';
  TemplateDescriptionLabel = 'Description';
  SelectLabel = 'Select';
  CancelLabel = 'Cancel';
  public templates: GridData<TemplatePlan<any>>;
  public searchInput: string;
  private pageNumber: number = 1;
  public form: FormGroup;
  public loading: boolean = false;
  public expandAll: boolean = false;
  public pageLoading: boolean = false;
  @ViewChild('table') table: any;
  @ViewChild('accordion') accordionComponent: NbAccordionComponent;
  @ViewChild('myInput') myInput: ElementRef;

  TutorialIDs = TutorialIDs;

  SelectedPlan: BasePlan = null;

  TemplateSource: DataSource;

  isFromTutorial: boolean = false;
  user: User = null;

  AppendToCurrentPlan: boolean = false;
  selectedDays: any = {};

  constructor(
    private service: BasePlanData<T>,
    private dialogService: NbDialogService,
    protected ref: NbDialogRef<any>,
    public joyrideService: JoyrideService,
    private tutorialService: TutorialData,
    private fb: FormBuilder
  ) {
    this.TemplateSource = this.service.GridPlanTemplateDataSource;
    this.form = this.fb.group({
      parents: this.fb.array([]),
    });
  }

  ngOnInit() {
    if (this.isFromTutorial) {
      // tutorial
      const tutorialStates = JSON.parse(this.user.tutorialStates ?? '{}');

      if (!tutorialStates[TutorialIDs.SelectTemplate] && this.isFromTutorial) {
        const steps = [];

        // add fake steps to make correct step numbers
        // for (let i = 0; i < 5; i++) steps.push('');

        steps.push(TutorialIDs.SelectTemplate);

        // add fake steps to make correct step numbers
        // for (let i = 0; i < 1; i++) steps.push('');

        this.joyrideService
          .startTour(
            {
              steps: steps,
              showPrevButton: false,
              showCounter: true,
            }, // Your steps order
          )
          .subscribe(
            (step) => {
              /*Do something*/
            },
            (error) => {
              /*handle error*/
            },
            () => {
              /*Tour is finished here, do something*/
            },
          );
      }
    }
    this.loading = true;
    this.loadTemplates();
  }

  ngAfterViewInit() {
  setTimeout(() => {
    this.myInput.nativeElement.blur();
  }, 0);
}

  public get isAnyDaySelected(): boolean {
    const {parents} = this.form.value;
    return parents.some(item=> item.parent === true || item.indeterminate=== true);
  }

  onSearchChange(event: any): void {
    if(this.loading) return;
    if(event.target.value) this.searchInput = event.target.value;
    else this.searchInput = null;
    this.pageNumber = 1;
    this.loading = true;
    this.loadTemplates();
  }

  public onExpandChange() {
    this.expandAll = !this.expandAll;
    if(this.expandAll) {
      this.accordionComponent.multi = true;
      this.accordionComponent.openAll();
    } else {
      this.accordionComponent.multi = false;
      this.accordionComponent.closeAll();
    }
  }

  onScroll(event: any) {
    const position = Math.floor(event.target.clientHeight + Math.round(event.target.scrollTop));
    const height = event.target.scrollHeight;
    if (this.isApproximatelyEqual(position, height) && !this.pageLoading && this.templates.items.length !== this.templates.totalCount) {
      this.pageNumber += 1;
      this.pageLoading = true;
      this.loadTemplates();
    }
  }

  isApproximatelyEqual(x, y) {
    return Math.abs(x - y) <= 1;
  }

  public loadTemplates(): void {
    let filters: SmartPlanTemplateGridFilter = {
      pageNumber: this.pageNumber,
      pageSize: 20,
      selectedTemplate: true,
    };
    if(this.searchInput) filters.filterByName = this.searchInput;

    this.service.list(filters).subscribe((res: GridData<TemplatePlan<any>>) => {
      if(this.pageLoading) this.templates.items = [...this.templates.items, ...res.items]
      else if(res.items.length != 0 || res.totalCount == 0) this.templates = res;
      this.initiateForm(this.templates);
      this.loading = false;
      this.pageLoading = false;
    });
  }

private initiateForm(templates): void {
    this.form = this.fb.group({
      parents: this.fb.array([]),
    });
  const parentsFormArray = this.form.get('parents') as FormArray;

  templates?.items?.forEach((parent, index: number) => {
    let childrenFormArray: FormArray;
    if(parent.thePlan?.days) {
      if(this.isFromTutorial && index == 0) {
        if(this.selectedDays[parent.id]) this.selectedDays[parent.id] = [...this.selectedDays[parent.id], ...parent.thePlan.days];
        else this.selectedDays[parent.id] = parent.thePlan.days;
      }
      childrenFormArray = this.fb.array(
        this.getUniqueDayIds(parent.id).map((day) => this.fb.group({
          selected: this.isFromTutorial && index == 0? true:this.checkDayIsSelected(parent.id, day),
          dayId: day
        }))
      );
    }

    const parentFormGroup = this.fb.group({
      parent: this.fb.control(this.isFromTutorial && index == 0? true: false),
      children: childrenFormArray,
      indeterminate: this.fb.control(false),
      description: [parent.description],
      name: [parent.name],
      note: [parent.note],
      planId: [parent.id]
    });
    if(childrenFormArray) {
        const allSelected = childrenFormArray.value.every((child)=> child.selected);
        const someSelected = childrenFormArray.value.some((child)=> child.selected) && !allSelected;
        parentFormGroup.get('parent').setValue(allSelected, { emitEvent: false });
        parentFormGroup.get('indeterminate').setValue(someSelected, { emitEvent: false });
    }

    parentFormGroup.get('children').valueChanges.subscribe((children) => {
      const parentValues = parentFormGroup.value;
      const allSelected = children?.every((child)=> child.selected);
      const someSelected = children?.some((child)=> child.selected) && !allSelected;
      parentFormGroup.get('parent').setValue(allSelected, { emitEvent: false });
      parentFormGroup.get('indeterminate').setValue(someSelected, { emitEvent: false });
      const selectedChildren = children?.filter(x => x.selected);
      const selectedTemplate = this.templates.items.find(x => x.id == parentValues.planId);
      if(this.selectedDays) {
        this.selectedDays[parentValues.planId] = selectedChildren?.map(x => {
          const findInSelectedDays = this.selectedDays[parentValues.planId]?.find(z => z.id === x.dayId);
          if(findInSelectedDays) {
            return findInSelectedDays;
          } else {
            return selectedTemplate.thePlan.days.find(z => z.id === x.dayId);
          }
        });
        if (this.selectedDays[parentValues.planId] && this.selectedDays[parentValues.planId].length == 0) {
          delete this.selectedDays[parentValues.planId];
        }
      }
    });
    parentFormGroup.get('parent').valueChanges.subscribe(res => {
        const temp = (parentFormGroup.get('children') as FormArray).value?.map((child) => ({
          ...child,
          selected: res,
        }));
        (parentFormGroup.get('children') as FormArray).setValue(temp);
    });
    parentsFormArray.push(parentFormGroup);
  });
}

onCheckboxClick(event: Event): void {
  event.stopPropagation();
}

private getUniqueDayIds(planId){
  const uniqueIdsSet = new Set();
  this.selectedDays[planId]?.forEach(item => uniqueIdsSet.add(item.id));
  this.templates?.items?.find(x => x.id == planId).thePlan?.days?.forEach(item => uniqueIdsSet.add(item.id));
  return [...uniqueIdsSet];
}

checkDayIsSelected(planId, dayId): boolean {
  if(this.selectedDays[planId]) {
    const selected = this.selectedDays[planId].find(x => x.id == dayId);
    return !!selected;
  }
  return false;
}

public get totalSelectedDays(): number {
  let total = 0;
  Object.values(this.selectedDays).forEach((item: any) => {
    if(item?.length) total += item?.length;
  });
  return total;
}

  /**
   * Event handler of RowSelect event.
   * @param $event Event object
   */
  RowSelected($event) {
    const EmtpyTemplates: any = this.TemplateSource;

    // clear all items set
    for (const template of EmtpyTemplates.data) {
      if (template.SelectedEvent != null) template.SelectedEvent(false);
    }

    $event.data.isSelected = $event.isSelected;

    if ($event.isSelected) {
      this.SelectedPlan = $event.data.thePlan;
    } else {
      this.SelectedPlan = null;
    }

    if ($event.data.SelectedEvent != null)
      $event.data.SelectedEvent($event.isSelected);
  }

  /**
   * Event handler of 'SelectPlan' action.
   */
  SelectPlan() {
    let firstParent = this.form.value.parents.find(x => x.parent || x.indeterminate=== true);
    let out = {
      "days": Object.values(this.selectedDays).reduce((acc: any, currArray) => acc.concat(currArray), []),
      "id": 36,
      "patientID": 0,
      "name": firstParent.name,
      "description": firstParent.description,
      "notes": firstParent.note,
      "active": false,
      "zOrder": 2147483647,
      "duration": 2,
      "createdDate": "0001-01-01T00:00:00",
      "updatedDate": "0001-01-01T00:00:00",
      "createdByUserId": 0,
      "updatedByUserId": 0,
      "hasError": false
    }
    if (this.selectedDays !== null && this.selectedDays !== undefined) {
      if (this.isFromTutorial && this.joyrideService.isTourInProgress()) {
        this.tutorialService.save(TutorialIDs.SelectTemplate).subscribe(() => {
          const tutorialStates = JSON.parse(this.user.tutorialStates);
          tutorialStates[TutorialIDs.SelectTemplate] = true;
          this.user.tutorialStates = JSON.stringify(tutorialStates);
        });

        this.joyrideService.closeTour();

        this.ref.close({
          plan: out,
          appendToCurrentPlan: this.AppendToCurrentPlan,
        });
      } else {
        if (this.AppendToCurrentPlan) {
          this.ref.close({
            plan: out,
            appendToCurrentPlan: this.AppendToCurrentPlan,
          });
        } else {
          this.dialogService
            .open(ConfirmMessageDialogComponent, {
              closeOnEsc: true,
              closeOnBackdropClick: true,
              context: {
                Message:
                  'Loading from template will overwrite the current plan, are you sure?',
              },
            })
            .onClose.subscribe((result) => {
              if (result) {
                this.ref.close({
                  plan: out,
                  appendToCurrentPlan: this.AppendToCurrentPlan,
                });
              }
            });
        }
      }
    }
  }

  /**
   * Event handler of 'Cancel' action.
   */
  Cancel() {
    this.ref.close();
  }
}

/**
 * Component for Plan Template Selection.
 */
@Component({
  selector: 'app-plan-template-select',
  templateUrl: './plan-template-select.component.html',
  styleUrls: ['./plan-template-select.component.scss'],
})
export class PlanTemplateSelectComponent extends BasePlanTemplateSelectComponent<MealPlan> {
  constructor(
    protected ref: NbDialogRef<PlanTemplateSelectComponent>,
    public planJoyrideService: JoyrideService,
    planService: MealPlanData,
    planDialogService: NbDialogService,
    planTutorialService: TutorialData,
    fb: FormBuilder
  ) {
    super(
      planService,
      planDialogService,
      ref,
      planJoyrideService,
      planTutorialService,
      fb
    );
  }
}

/**
 * Component for Fitness Plan Template Selection.
 */
@Component({
  selector: 'app-fitness-plan-template-select',
  templateUrl: './plan-template-select.component.html',
  styleUrls: ['./plan-template-select.component.scss'],
})
export class FitnessPlanTemplateSelectComponent extends BasePlanTemplateSelectComponent<FitnessPlan> {
  constructor(
    protected ref: NbDialogRef<FitnessPlanTemplateSelectComponent>,
    public fitnessPlanJoyrideService: JoyrideService,
    fitnessPlanService: FitnessPlanData,
    fitnessPlanDialogService: NbDialogService,
    fitnessPlanTutorialService: TutorialData,
    fb: FormBuilder
  ) {
    super(
      fitnessPlanService,
      fitnessPlanDialogService,
      ref,
      fitnessPlanJoyrideService,
      fitnessPlanTutorialService,
      fb
    );
  }
}
